export enum QuestionType {
  FULL_TEXT = 'FULL_TEXT',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTI_CHOICE = 'MULTI_CHOICE',
  NUMERIC = 'NUMERIC',
  BOOLEAN = 'BOOLEAN',
}

export interface ExtractionQuestion {
  id?: number;
  type: QuestionType;
  text: string;
  required: boolean;
  orderIndex: number;
  options?: string[];
}
